import React from "react"
import { StyleSheet, View } from "react-native"
import TextM from "./TextM"
import { theme } from "@common/theme/theme"

export const BulletTextM = ({ text, style, textStyle, endComponent }) => {
    return (
        <View style={[styles.item, style]}>
            <View style={styles.bullet} />
            <View style={styles.textContainer}>
                <TextM fontSize={16} wrap style={textStyle}>
                    {text}
                </TextM>
                {endComponent}
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    item: {
        flexDirection: "row",
        alignItems: "flex-start",
        marginBottom: 8,
    },
    bullet: {
        width: 6,
        height: 6,
        borderRadius: 3,
        backgroundColor: theme.colors.primary,
        marginRight: 10,
        marginTop: 7
    },
    textContainer: {
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 10,
        flex: 1,
    },
})
